<app-header *ngIf="!activeFormulaE"></app-header>
<main [ngClass]='activeFormulaE ? "pt-0" : ""'>
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
<app-loading-global *ngIf='loading'></app-loading-global>
